'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIDialogCloseButton;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('HubStyleTokens/sizes');

var _Color = require('../core/Color');

var _HoverProvider = require('../providers/HoverProvider');

var _HoverProvider2 = _interopRequireDefault(_HoverProvider);

var _colors = require('HubStyleTokens/colors');

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getOffset = (0, _styledComponents.css)(['right:40px;top:40px;']);

var getDetachedStyle = function getDetachedStyle(hovered, size) {
  return (0, _styledComponents.css)(['@media only screen and (min-width:50em){color:', ';position:absolute;', ';&::after{background:', ';}}'], hovered && _colors.MONOLITH, size === 'xl' && getOffset, (0, _Color.rgba)(_colors.OLAF, 0.1));
};

var CloseButton = (0, _styledComponents2.default)(function (props) {
  var __detached = props.detached,
      rest = _objectWithoutProperties(props, ['detached']);

  return _react2.default.createElement(_UICloseButton2.default, rest);
}).withConfig({
  displayName: 'UIDialogCloseButton__CloseButton'
})(['top:', ';', ';'], _sizes.MODAL_CLOSE_BUTTON_OFFSET, function (props) {
  return props.detached && getDetachedStyle(props.hovered, props.size);
});

function UIDialogCloseButton(props) {
  var className = props.className,
      detached = props.detached,
      size = props.size,
      rest = _objectWithoutProperties(props, ['className', 'detached', 'size']);

  var computedSize = detached && size == null ? 'xl' : size;
  return _react2.default.createElement(
    _HoverProvider2.default,
    props,
    function (hoverProviderProps) {
      return _react2.default.createElement(CloseButton, _extends({
        className: (0, _classnames2.default)('uiDialog-closeButton', 'private-modal__control', 'private-modal__close', className)
      }, rest, hoverProviderProps, {
        detached: detached,
        size: computedSize
      }));
    }
  );
}

UIDialogCloseButton.propTypes = {
  detached: _propTypes2.default.bool.isRequired,
  size: _UICloseButton2.default.propTypes.size
};

UIDialogCloseButton.defaultProps = {
  detached: false
};

UIDialogCloseButton.displayName = 'UIDialogCloseButton';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/UIDialogCloseButton.js
// module id = 204
// module chunks = 177